import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button, Text } from 'components';
import { REFERRAL_COLORS } from './theme';

const Shell = styled.div`
  min-height: calc(100vh - 74px);
  background-color: ${REFERRAL_COLORS.bg};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const IconRing = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: ${REFERRAL_COLORS.secondaryCircle};
  border: 1px solid ${REFERRAL_COLORS.mutedText}40;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  margin-bottom: 20px;
`;

const ReferralErrorState = ({ icon = '⚠️', title, body, onRetry }) => {
  const { t } = useTranslation();
  return (
    <Shell>
      <Card>
        <IconRing>{icon}</IconRing>
        <Text h3 bold col={REFERRAL_COLORS.white} marg="0 0 8px">
          {title}
        </Text>
        <Text b1 col={REFERRAL_COLORS.mutedText} marg="0 0 24px">
          {body}
        </Text>
        {onRetry && (
          <Button
            wid="100%"
            bg={REFERRAL_COLORS.cta}
            text={t('referral.tryAgain')}
            onClick={onRetry}
          />
        )}
      </Card>
    </Shell>
  );
};

export default ReferralErrorState;
